import styles from "./Footer.module.scss";
import iconStyles from "../Icon.module.scss";
import buttonStyles from "../Button.module.scss";
import { useRef } from "react";
import BankTransferModal, {
  BankTransferModalHandle,
} from "../BankTransferModal/BankTransferModal";

const Footer = () => {
  const modalBankRef = useRef<BankTransferModalHandle | null>(null);

  const openBankDetails = () => {
    modalBankRef.current?.onOpen();
  };

  return (
    <>
      <footer style={{ gridArea: "footer" }} className={styles.footer}>
        <div className={styles.org}>
          <div className={styles["org-details"]}>
            <div className={styles.logo}>
              <img src="logo-white.svg" alt="logo" />
            </div>
            <h6>
              International Reformed Evangelical Church
              <br />
              in Stockholm
            </h6>
            <p>Organization number: 252005-0903</p>
          </div>
          <div className={styles.address}>
            <div className={styles.title}>Address</div>
            <p>
              <a
                href="https://maps.app.goo.gl/g8RKKjJ7aixyCanA7"
                rel="noreferrer"
                target="_blank"
              >
                Storgatan 49, 17152 Solna
              </a>
            </p>
          </div>
          <div className={styles.contact}>
            <div className={styles.wrapper}>
              <a
                href="https://www.facebook.com/people/PRII-Stockholm-IREC-Stockholm/100089208450489/?locale2=en"
                className={`${buttonStyles["icon-button-footer"]}`}
                target="_blank"
                rel="noreferrer"
              >
                <i
                  className={`${iconStyles.icon} ${styles.icon} ${iconStyles.facebook}`}
                ></i>
              </a>
              <a
                href="https://www.instagram.com/irec.stockholm"
                className={`${buttonStyles["icon-button-footer"]}`}
                target="_blank"
                rel="noreferrer"
              >
                <i
                  className={`${iconStyles.icon} ${styles.icon} ${iconStyles.instagram}`}
                ></i>
              </a>
              <a
                href="https://www.youtube.com/channel/UCJGpw2y2fAQ97CMXRpdPGMw"
                className={`${buttonStyles["icon-button-footer"]}`}
                target="_blank"
                rel="noreferrer"
              >
                <i
                  className={`${iconStyles.icon} ${styles.icon} ${iconStyles.youtube}`}
                ></i>
              </a>
              <a
                href="mailto:irec.stockholm@gmail.com"
                className={`${buttonStyles["icon-button-footer"]}`}
                target="_blank"
                rel="noreferrer"
              >
                <i
                  className={`${iconStyles.icon} ${styles.icon} ${iconStyles.email}`}
                ></i>
              </a>
            </div>
            <p>Offerings via Swish (123 697 98 84)</p>
            <p style={{ marginTop: 0 }}>
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  openBankDetails();
                }}
              >
                Bank transfer details
              </a>
            </p>
          </div>
        </div>
        <div className={styles.links}>
          <p className={styles.title}>IREC Europe</p>
          <a target="_blank" rel="noreferrer" href="https://irec-berlin.org/">
            IREC Berlin
          </a>
          <a
            target="_blank"
            rel="noreferrer"
            href="https://www.grii-hamburg.org/"
          >
            IREC Hamburg
          </a>
          <a
            target="_blank"
            rel="noreferrer"
            href="http://translate.google.com/translate?js=n&sl=id&tl=en&u=http://grii-munich.org"
          >
            IREC Munich
          </a>
          <a
            target="_blank"
            rel="noreferrer"
            href="http://www.grii-bern.org/en/"
          >
            IREC Swiss
          </a>
          <a
            target="_blank"
            rel="noreferrer"
            href="https://music.irec-europe.org/"
          >
            Music by IREC Europe
          </a>
        </div>
        <div className={styles.links}>
          <p className={styles.title}>Other links</p>
          <a target="_blank" rel="noreferrer" href="https://stemi.org/">
            Stephen Tong Evangelical Ministry International
          </a>
          <a
            target="_blank"
            rel="noreferrer"
            href="https://www.recjakarta.com/"
          >
            Reformed Evangelical Church Jakarta
          </a>
          <a target="_blank" rel="noreferrer" href="https://www.reformed21.tv/">
            Reformed 21
          </a>
          <a target="_blank" rel="noreferrer" href="https://plkmomentum.com/">
            Momentum Christian Literature
          </a>
          <a
            target="_blank"
            rel="noreferrer"
            href="https://aulasimfoniajakarta.com/en"
          >
            Aula Simfonia Jakarta
          </a>
        </div>
      </footer>
      <BankTransferModal ref={modalBankRef} />
    </>
  );
};

export default Footer;
